module.exports = __webpack_public_path__ + "media/img/event/SBT-Promo-EDM-82afa13f3c348ef99210d1f06f45f3b9.jpg";